import { Box, InputAdornment, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { FilterAlt, Search } from '@mui/icons-material';
import { useEffect } from 'react';
import {
  searchAgentContacts,
  selectDropDownQueryValue,
  selectSearchBoxQueryValue,
} from '../+state/ccf-directory.slice';
import { CcfDeboucedInput, useTranslator } from '@nice-ccf/ui-controls';
import { selectAppSpaceActiveTab } from '@nice-ccf/ui-components';
import { AppSpace } from '../../../enums/app-space-tabs';

export interface CcfDirectorySearchProps {
  placeHolder?: string;
  updateSearchQuery: any;
  isFilterIcon?: boolean;
}

/**
 * Component to be used for directory search
 * @param param0 - any
 * @example <CcfDirectorySearch />
 * @returns
 */
export const CcfDirectorySearch = (props: CcfDirectorySearchProps) => {
  const { placeHolder, updateSearchQuery, isFilterIcon } = props;
  const dispatch = useDispatch();
  const [translate] = useTranslator();
  const theme = useTheme();
  const type = theme.palette.mode;
  const placeHolderValue = placeHolder
    ? placeHolder.toString()
    : translate('agentSearchBox');
  const searchValue = useSelector(selectSearchBoxQueryValue);
  const activeAppSpaceTab = useSelector(selectAppSpaceActiveTab);
  const selectedDropDownValue = useSelector(selectDropDownQueryValue);
  useEffect(() => {
    return () => {
      if (activeAppSpaceTab === AppSpace.DIRECTORY) {
        updateSearchQuery('');
        dispatch(searchAgentContacts(''));
      }
    };
  }, []);

  /**
   * Function to dispatch action to search agent contacts
   * @param e -  React.ChangeEvent
   * @example dispatchQueryUpdateAction(e)
   */
  function dispatchQueryUpdateAction(
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) {
    updateSearchQuery(e.target.value);
    dispatch(searchAgentContacts(e.target.value));
  }

  return (
    <Box bgcolor="background.level1" sx={{ marginLeft: '5px' }}>
      <CcfDeboucedInput
        disabled={selectedDropDownValue === 'people'}
        size="small"
        style={{
          background: type === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'white',
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search htmlColor="black" />
            </InputAdornment>
          ),
          endAdornment: isFilterIcon && (
            <InputAdornment position="end">
              <FilterAlt />
            </InputAdornment>
          ),
        }}
        onChange={dispatchQueryUpdateAction}
        placeholder={placeHolderValue}
        variant="outlined"
        fullWidth
        delay={1000}
        value={searchValue}
      />
    </Box>
  );
};
